const initialState = {
  allOperatorsExpenses: [],
  operatorExpenseList: [],
  expenseUploadSheetError: "",
};
export default initialState;
